export default function displayTimeOffTypeFilter(LeaveService) {
  'ngInject';

  return function displayTimeOffType(timeOffType) {
    const type = LeaveService.timeOffTypes.find((t) => t.id === timeOffType);
    if (!type) {
      return 'Leave';
    }
    return type.name;
  };
}
